/* @flow */
import Group from 'entities/Group';
import Organization from 'entities/Organization';
import Mock from 'lib/Mock';
import { STUDENT, PARENT, EVERYONE, ADMIN, TEACHER, RCE, UNKNOWN } from 'utils/roleHelpers';

let id = 0;

class GroupMock extends Mock<Group> {
  Model = Group;

  base = function() {
    id += 1;

    const code = 'test' + id;

    return {
      id,
      name: code,
      class_name: 'Test Class ' + id,
      avatar: '/assets/images/avatars/general-1.svg',
      pdf_url: 'http://pdfs.remind.com/invite?',
      join_url: `https://www.remind.com/join/${code}`,
      subscribe: {
        sms: {
          raw: '81010',
          uri: 'sms://81010',
          pretty: '81010',
        },
        sms_alternate: {
          raw: '(415) 798-2410',
          uri: 'sms://(415) 798-2410',
          pretty: '(415) 798-2410',
        },
        email: {
          raw: `${code}@mail.remind.com`,
          uri: `mailto:${code}@mail.remind.com`,
          pretty: `${code}@mail.remind.com`,
        },
      },
      type: 'owned',
      user: {
        id: 1234,
        signature: 'Mr. Dan',
      },
      roles: [{ role: STUDENT, count: 1 }],
      permissions: {},
      grades: [],
      subject: null,
    };
  };

  withClassCode = function(code) {
    return {
      name: code,
      join_url: `https://www.remind.com/join/${code}`,
      subscribe: {
        sms: {
          raw: '81010',
          uri: 'sms://81010',
          pretty: '81010',
        },
        sms_alternate: {
          raw: '(415) 798-2410',
          uri: 'sms://(415) 798-2410',
          pretty: '(415) 798-2410',
        },
        email: {
          raw: `${code}@mail.remind.com`,
          uri: `mailto:${code}@mail.remind.com`,
          pretty: `${code}@mail.remind.com`,
        },
      },
    };
  };

  withOwner = function(user) {
    return {
      owners: [user],
      permissions: {
        can_post: true,
        can_edit: true,
        can_delete: true,
        can_add_people: true,
        postable_roles: [EVERYONE, STUDENT, PARENT],
      },
    };
  };

  hasUnder13 = {
    has_children: true,
  };

  hasSubscribersInitiatedChats = {
    subscriber_initiated_chats: true,
  };

  hasMessages = {
    messages_count: 7,
  };

  hasSubscribers = {
    memberships_count: 101,
  };

  isSubscribed = {
    type: 'subscribed',
  };

  isStaffClass = {
    type: 'organization',
  };

  withRoles = {
    roles: [
      { role: ADMIN, count: 25 },
      { role: RCE, count: 20 },
      { role: TEACHER, count: 15 },
      { role: STUDENT, count: 10 },
      { role: PARENT, count: 5 },
      { role: UNKNOWN, count: 1 },
    ],
    memberships_count: 76,
  };

  isArchived = {
    archived_at: new Date(),
    original_organization_id: 1,
    organization_id: null,
  };
  atOrganization = {
    organization: new Organization({ id: 1 }),
  };
  withGrades = {
    grades: [
      { name: '9th Grade', short_name: '9th', code: 'G09' },
      { name: '10th Grade', short_name: '10th', code: 'G10' },
      { name: '11th Grade', short_name: '11th', code: 'G11' },
    ],
  };
  withSubject = {
    subject: { name: 'Algebra', subject_code: 'algebra' },
  };
  isDistrict = {
    type: 'district',
  };
  isSchool = {
    type: 'organization',
  };
}

export default new GroupMock();
